import { Radio, RadioGroup as MuiRadioGroup, RadioGroupProps } from '@mui/material';
import { styled } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';

import { COLORS } from '~/styles/colors';

interface RadioOption {
  value: string | number;
  label: string;
}

interface CustomRadioGroupProps extends Omit<RadioGroupProps, 'onChange'> {
  value?: string | number;
  defaultValue?: string | number;
  radios: RadioOption[];
  onClick?: () => void;
}

export default function RadioGroup({ value, defaultValue, radios, onClick, ...rest }: CustomRadioGroupProps) {
  return (
    <StyledRadioGroup value={value} defaultValue={defaultValue} {...rest}>
      {radios.map((item) => (
        <StyledFormControlLabel
          key={item.value}
          value={item.value}
          onClick={onClick}
          control={
            <Radio
              sx={{
                color: COLORS.grey200,
                '&.Mui-checked': {
                  color: COLORS.primary,
                },
              }}
            />
          }
          label={item.label}
        />
      ))}
    </StyledRadioGroup>
  );
}

export const StyledRadioGroup = styled(MuiRadioGroup)(() => ({
  gap: '16px',
  flexDirection: 'row',
}));

export const StyledFormControlLabel = styled(FormControlLabel)(() => ({
  margin: 0,
  gap: '4px',
  '.MuiFormControlLabel-label': {
    color: COLORS.textMain,
  },
}));
